import { UPDATE_CALENDAR_COLLAPSED, UPDATE_COLLAPSED } from '@ttstr/actions/masonry';

export interface ReduxState {
  collapsed: boolean;
  calendarCollapsed: boolean;
}

const initialState: ReduxState = {
  collapsed: true,
  calendarCollapsed: true,
};

const masonry = (state: ReduxState = initialState, action: any): ReduxState => {
  switch (action.type) {
    case UPDATE_COLLAPSED: {
      return {
        ...state,
        collapsed: action.payload.collapsed,
      };
    }
    case UPDATE_CALENDAR_COLLAPSED: {
      return {
        ...state,
        calendarCollapsed: action.payload.calendarCollapsed,
      };
    }
    default:
      return state;
  }
};

export default masonry;
